<template>
  <SidePanel
    :isVisible="true"
    @cancel="onCancel"
    :header="header"

  >
    <div class="sidepanel-body">
      <div class="upload-image-section">
        <div class="panel-section-header text-panel-section-header mt-2">
          {{ $t('customLogo.logoImageUploadSectionHeader') }}
        </div>

        <div class="upload-image"> 
          <div class="label">
            <label> {{ $t('customLogo.uploadYours') }} </label>
          </div>
          <div class="input-upload mt-2" v-if="user">
            <input type="file" ref="fileupload" id="selectedFile" accept="image/*" @change="onFileChange" style="display: none;" />
            <input type="button" :value="$t('options.browseImage')" onclick="document.getElementById('selectedFile').click();" />
          </div>
          <div class="input-upload mt-2" v-else>
            <label v-html="$t('options.customImageInstruction1')"></label>
            <label v-html="$t('options.customImageInstruction2')"> </label>
            <label> {{ $t('options.customImageInstruction3') }} </label>
          </div>
        </div>
        <div class="image-preview-section mt-3" v-if="url">
          <div class="image-preview"> 
            <label> <i>{{ $t('options.imagePreview') }}</i> </label>
            <img class="img-width small-width" :src="url" />
          </div>
          <div class="image-upload">
            <p> {{ fileName }} </p>
            <Btn
              @click.native="uploadImage"
              :label="$t('customLogo.addYourLogo')"
              class="mt-2"
              :loading="isUploading"
            />
          </div>
        </div>
      </div>

      <div class="panel-section-header text-panel-section-header mt-2">
        {{ $t('customLogo.selectedLogo') }}
      </div>

      <div class="image-galery" v-if="user && user.logos.length > 0">
        <div
          v-for="image in user.logos"
          :key="image.id"
          class="bg-image"
        >
          <img loading="lazy" @click="select(image)" class="img-width" :src="imageName(image.url, true)" />
          <div v-if="image.id == selected" class="icons">
            <font-awesome-icon class="" :icon="['fal', 'check']" />
          </div>
          <div class="icons right-icons" @click="deleteImage(image.id)">
            <font-awesome-icon class="" :icon="['fal', 'times']" />
          </div>
        </div>
      </div>

      <div class="mt-3" v-else>
        <p> {{ $t('customLogo.notUploadedBackgroundLogo') }} </p>
      </div>

      <!-- <div class="panel-section-header text-panel-section-header mt-2">
        {{ $t('customLogo.logoLink') }}
      </div>

      <div class="logo-link-section">
        <div class="mt-3">
          <p> {{ $t('customLogo.changeLogoLink') }} </p>
        </div>
        <div class="logo-link-input">
          <InputText
            id="logo-link-text"
            :placeholder="$t('customLogo.linkOfLogo')"
            v-model="logoLink"
          />
        </div>
        <div v-if="linkAck" class="linkAck mt-2">
          {{ linkAck }}
        </div>
      </div> -->

      <ModalPremiumFeatureDialog
        ref="dlgPremiumFeatureDialog"
      />
    </div>
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import { pollMixin } from '@/components/mixins/PollMixins.js';
// import InputText from '@/components/UI/InputText.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import { HTTP } from '@/shared/http';
import ModalPremiumFeatureDialog from '@/components/~Global/Dialogs/ModalPremiumFeatureDialog';

export default {
  name: 'EditLogo',
  mixins: [pollMixin],
  props: ['options'],

  components: {
    SidePanel,
    ModalPremiumFeatureDialog,
    // InputText
  },

  data() {
    return {
      localDetails: null,
      selected: -1,
      backgroundThumbnail: '/images/thumbnail.webp',
      url: '',
      fileName: '',
      formData: new FormData(),
      isUploading: false,
      // logoLink: '',
      linkAck: null,
      min: 22,
      max: 65,
      selectedSize: [this.min, this.max],
    };
  },
  // created() {
  //   this.logoLink = this.poll.options.logoLink ? this.poll.options.logoLink : window.location.origin;
  // },
  computed: {
    ...mapState({
      // poll: (state) => state.poll.poll,
      user: (state) => state.Login.user,
    }),

    ...mapGetters(['images', 'getSelectedTemplate', 'isPremium']),

    header() {
      return this.$t('options.selectLogo')
    },
    cancelText() {
      return 'Zurück';
    },
    getSelectedSize() {
      return this.selectedSize;
    }
  },

  methods: {
    ...mapActions(['addLogoInUserLogos', 'replaceLogosToUserImagesObject', 'updateSelectedTemplate']),
    select(image) {
      if(this.isPremium) {        
        this.selected = image.id;
        this.$store.commit('setLogo', image);
        this.getSelectedTemplate.config.logoDetails.logoImg = image.url;
        this.updateSelectedTemplate(this.getSelectedTemplate);
        document.getElementById("web-logo").src = image.url;
      } else {
        this.$refs.dlgPremiumFeatureDialog.openModal(event);
      }
    },

    onCancel() {
      // save the current selected background
      this.$emit('cancel', "editLogo");
    },
    imageName(url, custom = false) {
      if(url) {
        let smUrl = '';
        if(custom == false) {
          smUrl = url.replace('/images/', '/images/');
        } else {
          smUrl = url.replace('/storage/', '/storage/');
        }
        return smUrl;
      }
      return null;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if(file) {
        this.fileName = e.target.files[0].name;
        this.url = URL.createObjectURL(file);
        this.formData.append("file", file);
      } else {
        this.reset();
      }
    },
    uploadImage() {
      this.isUploading = true;
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/logo/upload';
      HTTP.post(url, this.formData)
        .then((response) => {
          this.reset();
          if(response.data) {
            this.addLogoInUserLogos(response.data);
          }
        })
        .catch((err) => {
          this.reset();
          alert(this.$t(err.response.data.error));
        });
    },
    deleteImage(id) {
      const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = apiUrl + '/logo/delete/' + id;
      HTTP.delete(url)
        .then((response) => {
          this.replaceLogosToUserImagesObject(response.data);
          if(this.selected == id) {
            document.getElementById("web-logo").src = '/images/logo_neu_weiss_blau_orange.png';
          }
        })
        .catch((err) => {
          alert(this.$t(err.response.data.error));
        });
    },
    reset() {
      this.url = null;
      this.formData.delete('file');
      this.$refs.fileupload.value=null;
      this.isUploading = false;
    },
    // saveLogoURL() {
    //   this.isUploading = true;
    //   const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
    //   const url = apiUrl + '/poll/option/update/' + this.poll.id;

    //   this.poll.options.logoLink = this.logoLink;
    //   HTTP.put(url, {options: this.poll.options})
    //   .then(() => {
    //     this.$store.commit('updatelogoLink', this.logoLink);
    //     this.linkAck ="Link saved."
    //   })
    //   .catch((err) => {
    //     this.linkAck ="something went wrong."
    //     console.error();(err);
    //   })
    //   .finally(() => {
    //     let timeout = window.setTimeout(() => {
    //       this.linkAck = null;
    //       clearTimeout(timeout);
    //     }, 1000);
    //     this.isUploading = false;
    //   });
    // }
  },

  mounted() {
    // if(this.poll.logo_image_path) {
    //   const curImagePath = this.poll.logo_image_path;
    //   let userLogos = this.user ? this.user.logos : [];
    //   this.selected = this.findLogoFromListUsingURL(userLogos, curImagePath);
    // }
    if(this.getSelectedTemplate) {
      let userLogos = this.user ? this.user.logos : [];
      this.selected = this.findLogoFromListUsingURL(userLogos, this.getSelectedTemplate.config.logoDetails.logoImg);
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/style.scss';
input.form-control:focus {
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.075) inset,
    0 0 0px rgba(126, 239, 104, 0.6);
  outline: 0 none;
}

.image-galery {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

.bg-image {
  padding: 7px;
  position: relative;

}

.img-width {
  //width: 240px;
  width: 234px;
  height: 160px;
  border: solid 0px gray;
  border-radius: 15px;
}

.icons {
  position: absolute;
  top: 20px;
  left: 20px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  color: black;
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.12);
  background-color: $user-bubble;
  border-radius: 12px;
  width: 24px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  text-align: center;

  &.right-icons {
    right: 20px !important;
    left: unset;
    cursor: pointer;
  }
}

.panel-section-header {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 32px;
  margin-bottom: 8px;
  margin-top: 0px;
  line-height: 20px;
  margin-left: -16px;
  margin-right: -16px;
}

.image-preview-section {
  display: flex;
  font-size: $very-small;
  .image-preview {
    display: grid;
  }
  .image-upload {
    margin: auto;
    margin-left: 20px;
    font-size: $very-small;
    text-align: left;
    P {
      margin-bottom: 0px;
    }
  }
}

.input-upload {
  input[type=button] {
    background-color: $light-grey;
    border-radius: 5px;
    font-size: $very-small;
  }
  label.best-ratio {
    font-size: $very-small;
  }
}

.label {
  display: grid;
  label {
    font-weight: $semi-bold-weight;
    margin-bottom: 0px;
  }
}
.logo-link-section {
  .logo-link-input {
    display: flex;
  } 
}

// .linkAck {
//   font-size: $small;
//   text-align: center;
//   border-radius: 5px;
//   color: $white !important;
//   background-color: $primary-dark;
// }

.invite-copy[disabled] {
  pointer-events: none;
  cursor: not-allowed;
}

@media screen and (max-width: 480px) {
  .small-width {
    width: 180px;
    height: 120px;
  }
}
</style>
